import React from "react";
import App from "./App";
import ReactDOM from 'react-dom/client';
import { unmountComponentAtNode } from "react-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
class WebComponent extends HTMLElement {

  connectedCallback() {
    const root = ReactDOM.createRoot(this);
    const props = {
      objectDefinitionId: this.getAttribute('id'),
      objectDefinitionERC: this.getAttribute('erc'),
    };

const theme = createTheme();
    root.render(
      <ThemeProvider theme={theme}>
    <App {...props} />
    </ThemeProvider>
  );
  }

  disconnectedCallback() {
    unmountComponentAtNode(this);
  }
}

const ELEMENT_NAME = "reactjs-ext-delete-datas";

if (customElements.get(ELEMENT_NAME)) {
  console.log(
    `Skipping registration for <${ELEMENT_NAME}> (already registered)`
  );
} else {
  customElements.define(ELEMENT_NAME, WebComponent);
}
